export const Rules = {
    required: (value: string) => !!value || "Required.",
    email: (value: string) =>
        !value ||
        /^\w+([+.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) ||
        "E-mail must be valid",
};
